import React from 'react';
import { Link } from 'react-router-dom';
import {
  Squares2X2Icon,
  UserGroupIcon,
  BuildingStorefrontIcon,
  TagIcon,
} from '@heroicons/react/24/outline';
import Layout from '../../components/layout/Layout';

const cards = [
  {
    to: '/admin/produtos',
    icon: Squares2X2Icon,
    label: 'Produtos',
    description: 'Cadastrar, editar e remover itens do mostruário',
    color: 'bg-gray-100 text-gray-900',
  },
  {
    to: '/admin/usuarios',
    icon: UserGroupIcon,
    label: 'Usuários',
    description: 'Gerenciar vendedores e administradores',
    color: 'bg-green-50 text-green-700',
  },
  {
    to: '/admin/lojas',
    icon: BuildingStorefrontIcon,
    label: 'Lojas',
    description: 'Cadastrar e gerenciar lojas da rede',
    color: 'bg-orange-50 text-orange-700',
  },
  {
    to: '/admin/categorias',
    icon: TagIcon,
    label: 'Categorias e Marcas',
    description: 'Organizar tipos e fabricantes de produtos',
    color: 'bg-purple-50 text-purple-700',
  },
];

const Dashboard = () => (
  <Layout>
    <div className="mb-8">
      <h1 className="text-xl font-bold text-gray-900">Painel Administrativo</h1>
      <p className="text-sm text-gray-500 mt-1">Selecione uma área para gerenciar</p>
    </div>

    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {cards.map(({ to, icon: Icon, label, description, color }) => (
        <Link
          key={to}
          to={to}
          className="card p-6 hover:shadow-md transition-shadow duration-150 flex flex-col gap-3"
        >
          <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${color}`}>
            <Icon className="w-5 h-5" />
          </div>
          <div>
            <p className="font-semibold text-gray-900 text-sm">{label}</p>
            <p className="text-xs text-gray-500 mt-0.5 leading-snug">{description}</p>
          </div>
        </Link>
      ))}
    </div>
  </Layout>
);

export default Dashboard;
